import type { Tool } from "@repo/app-types/entities/tool";
import { DropdownMenu } from "@repo/ui/Dropdown/dropdownMenu";
import { IconDotsVertical } from "@tabler/icons-react";
import { type FC, useState } from "react";
import { Button, MenuTrigger } from "react-aria-components";
import { DeleteToolModal } from "./deleteToolModal.js";

interface ToolMoreMenuProps {
  tool: Tool;
  toolId: string;
  onToolDeleted: () => void;
}

interface MenuItem {
  label: string;
  onClick: () => void;
}

export const ToolMoreMenu: FC<ToolMoreMenuProps> = ({
  tool,
  toolId,
  onToolDeleted,
}) => {
  const [isDeleteWarningModalOpen, setIsDeleteWarningModalOpen] =
    useState(false);

  const menuItems: MenuItem[] = [
    {
      label: "Delete tool",
      onClick: () => setIsDeleteWarningModalOpen(true),
    },
  ];

  return (
    <>
      <div className="relative">
        <MenuTrigger>
          <Button className="relative flex items-center rounded-md bg-white p-1.5 text-foreground shadow-xs ring-1 ring-border-strong ring-inset hover:bg-gray-50 disabled:bg-disabled disabled:text-muted-foreground disabled:shadow-none">
            <span className="absolute -inset-1.5" />
            <span className="sr-only">Open tool menu</span>
            <IconDotsVertical className="h-6 w-6" />
          </Button>
          <DropdownMenu items={menuItems} />
        </MenuTrigger>
      </div>
      <DeleteToolModal
        isOpen={isDeleteWarningModalOpen}
        onClose={() => setIsDeleteWarningModalOpen(false)}
        toolId={toolId}
        toolName={tool.name}
        onToolDeleted={onToolDeleted}
      />
    </>
  );
};
